<template>
    <div class="BookmarkFold" aria-hidden="true"></div>
</template>

<script>
'use strict';

// Decorative folded-corner indicator pinned to the reader's top-right corner when the
// current page/location is bookmarked. Purely visual — see Reader.vue for the v-if gate
// and the wrapping <transition name="bookmark-fold"> that fades it in/out.
export default {
    name: 'BookmarkFold',
};
</script>

<style scoped>
/* The triangle is the accent-filled half of a 225deg gradient (top-right corner fold). */
.BookmarkFold {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    pointer-events: none;
    z-index: 25;
    background: linear-gradient(225deg, var(--theme-accent-color) 50%, transparent 50%);
    filter: drop-shadow(rgba(0, 0, 0, 0.15) -1px 1px 2px);
}

/* Fade in/out with the v-if gate (transition wrapper lives in Reader.vue). */
.bookmark-fold-enter-active {
    transition: opacity 0.2s ease-out;
}

.bookmark-fold-leave-active {
    transition: opacity 0.15s ease-in;
}

.bookmark-fold-enter,
.bookmark-fold-leave-to {
    opacity: 0;
}
</style>
